import { Grid, TextField, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import InputAdornment from "@mui/material/InputAdornment";
import { StatusBoxWrapper } from "./StatusBoxStyled";
import { useState } from "react";

const StatusBox = ({ inputInfo, handleStatusClick }) => {
  const [clickedInputIndex, setClickedInputIndex] = useState(-1);

  return (
    <StatusBoxWrapper>
      <Container maxWidth="xl">
        <Grid container spacing={2} className="statusboxContainer">
          {inputInfo.map((input, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index} sx={{ cursor: 'pointer' }}>
              <TextField
                onClick={() => {
                  handleStatusClick(input.id);
                  setClickedInputIndex(index);
                }}
                sx={{ cursor: 'pointer' }}
                className={`inputborder${index} ${clickedInputIndex === index ? `highlighted${index}` : ""}`}
                variant="outlined"
                fullWidth
                InputProps={{
                  readOnly: true,
                  // keep image + text inline
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.3,
                        paddingLeft: "0px",
                      }}
                    >
                      <img
                        src={input.imageSrc}
                        alt={`Statusbox_Icon_${index}`}
                        style={{ width: 20, height: 20, display: "block" }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "#1B4A83",
                        }}
                      >
                        {input.text}
                      </Typography>
                    </InputAdornment>
                  ),
                  // value stays at rightmost end
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ paddingRight: "10px" }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 700, color: "#333", cursor: 'pointer' }}
                      >
                        {input.value}
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </StatusBoxWrapper>
  );
};

export default StatusBox;
